import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class TopicAPI extends BaseAPI {}

export default new TopicAPI('v1/topics', 'Topic', getApiUrl(apis.CommonAPI))
